import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActions, Divider, Skeleton } from '@mui/material';

const CustomizableCardSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 1, position: 'relative' }}>
      <Card sx={{ borderRadius: '4px', width: '430px' }}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            height: '64px',
            justifyContent: 'space-between',
            p: 2,
          }}
        >
          <Skeleton height="25px" variant="text" width="280px" />
          <Skeleton height="25px" variant="rounded" width="80px" />
        </Box>
        <CardContent sx={{ p: 0 }}>
          <Skeleton height="40px" variant="rectangular" width="100%" />
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              justifyContent: 'flex-start',
              p: 1,
            }}
            width="100%"
          >
            <Skeleton height="30px" variant="rounded" width="40px" />
            <Skeleton height="25px" variant="text" width="280px" />
          </Box>
          <Skeleton height="40px" variant="rectangular" width="100%" />
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              justifyContent: 'flex-start',
              p: 1,
            }}
            width="100%"
          >
            <Skeleton height="30px" variant="rounded" width="40px" />
            <Skeleton height="25px" variant="text" width="280px" />
          </Box>
        </CardContent>
        <Divider />
        <CardActions
          sx={{
            alignSelf: 'stretch',
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2,
          }}
        >
          <Box
            sx={{
              alignItems: { sm: 'center', xs: 'stretch' },
              display: 'flex',
              flexDirection: { sm: 'row-reverse', xs: 'column' },
              justifyContent: { sm: 'space-between', xs: 'center' },
            }}
            width="100%"
          >
            <Skeleton height="40px" sx={{ borderRadius: '75px' }} variant="rounded" width="150px" />
            <Skeleton height="40px" sx={{ borderRadius: '75px' }} variant="rounded" width="150px" />
          </Box>
        </CardActions>
      </Card>
    </Box>
  );
};

export default CustomizableCardSkeleton;
